import * as React from 'react';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import {
  Card,
  Table,
  Stack,
  Box,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  CircularProgress,
  Pagination,
  TextField,
  MenuItem,
  Avatar,
  Tooltip,
  Modal
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';
import { api } from '../Api';
import { useTranslation } from 'react-i18next';
import EarningsDetailModal from 'src/sections/@dashboard/Earnings/EarningsDetailModal';

export default function Earnings() {
  const { t } = useTranslation();

  const TABLE_HEAD = [
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'norder', label: 'No of Orders', alignRight: false },
    { id: 'protectionfee', label: 'Protection Fee', alignRight: false },
    { id: 'total', label: 'Total Earning', alignRight: false },
    { id: 'action', label: t('Users.table.5'), alignRight: false }

    // { id: 'seller_earning', label: 'Seller Earning', alignRight: false },
    // { id: 'shipping_fee', label: 'Shipping Fee', alignRight: false },
    // { id: 'protection_fee', label: 'Protection Fee', alignRight: false }
  ];

  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'details'];

  function checkRender() {
    let check = 'earnings';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0].permission_types.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }
  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [loading, setloading] = useState(true);
  const [sorting, setsorting] = useState('');
  const [detailloading, setdetailloading] = useState(false);
  const [earningdetail, setearningdetail] = useState('');

  const [sortinglist, setsortinglist] = useState([
    { id: 1, name: 'Date Placed (Newest First)', value: 'date_newest_first' },
    { id: 2, name: 'Date Placed (Oldest First)', value: 'date_oldest_first' },
    { id: 3, name: 'No. of Items (Ascending)', value: 'asc' },
    { id: 4, name: 'No. of Items (Descending)', value: 'desc' }
  ]);

  useEffect(() => {
    if (sorting == '') {
      setsorting(sortinglist[0]);
    }
  }, [sorting]);

  function getEarnings(pagenumber, sort) {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    pagenumber && params.append('page', pagenumber);
    search.length > 0 && params.append('search', search);
    sort && params.append('orderBy', sort.value);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    const url = `${api.get_earning_by_users}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch orderss');
        }
      })
      .then((result) => {
        setlist(result.data);
        settotal_Earnings(result?.total_earning);
        result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
      })
      .catch((error) => {
        setlist([]);
        setpagesCount(0);
      })
      .finally(() => {
        setsearchLoading(false);
        setloading(false);
      });
  }

  function handlegetearningbyid(id) {
    console.log('id ======', id);
    setdetailloading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    params.append('user_id', id);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    const url = `${api.get_earning_by_user_id}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch orderss');
        }
      })
      .then((result) => {
        setearningdetail(result.data);
        setdetailloading(false);
      })
      .catch((error) => {
        setdetailloading(false);
      })
      .finally(() => {
        setdetailloading(false);
      });
  }

  useEffect(() => {
    setloading(true);
    getEarnings();
  }, []);

  const [search, setsearch] = useState('');
  const [searchLoading, setsearchLoading] = useState(false);
  const tableRef = React.createRef();
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  const [total_Earnings, settotal_Earnings] = useState(0);
  const [earningdetailmodal, setearningdetailmodal] = useState(false);
  const handlePageChange = (event, value) => {
    list.length = 0;
    setloading(true);
    setPage(value);
    getEarnings(value, sorting);
  };

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      setloading(true);
      getEarnings(page, sorting);
    }
  }, [search]);

  const isDataFound = list.length === 0;

  const handlesorting = (event) => {
    const newsort = event.target.value;
    list.length = 0;
    setloading(true);
    setsorting(newsort);
    setPage(1);
    getEarnings(1, newsort);
  };
  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };
  const boxStyle = {
    maxWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid'
    // borderColor: pallete.primary.main
  };

  const closeearningdetailmodal = () => {
    setearningdetailmodal(false);
    setearningdetail('');
  };
  return (
    <Page title={`Earnings | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Modal style={style} open={earningdetailmodal} onClose={closeearningdetailmodal}>
          <Box
            sx={boxStyle}
            px={4}
            pt={2}
            pb={5}
            style={{ backgroundColor: '#fafafb', overflowX: 'hidden' }}
          >
            <EarningsDetailModal
              handleClose={closeearningdetailmodal}
              earningdetail={earningdetail}
              loading={detailloading}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Earnings
          </Typography>
        </Stack>
        <Typography variant="h5" gutterBottom>
          Total = {total_Earnings} LKR
        </Typography>
        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between'
            }}
            className="top_options"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              placeholder="Search"
              onClickSearch={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getEarnings(1, sorting);
              }}
              onEnter={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getEarnings(1, sorting);
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              loading={searchLoading}
              variant="contained"
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getEarnings(1, sorting);
              }}
              className="width_full"
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            {/* <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={sorting}
              label={'Sort by'}
              onChange={handlesorting}
              className="width_full_status"
            >
              {sortinglist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField> */}
          </Box>
          <TableContainer sx={{ minWidth: 800 }}>
            <Scrollbar>
              <Table ref={tableRef}>
                <UserListHead headLabel={TABLE_HEAD} rowCount={TABLE_HEAD.length} />
                <TableBody>
                  {list.map((row) => {
                    const {
                      id,
                      name,
                      email,
                      total_orders_count,
                      total_earning,
                      avatar,
                      total_buyer_protection_fee
                    } = row;

                    return (
                      <TableRow key={id}>
                        <TableCell align="left">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 150 }}
                          >
                            <Avatar
                              alt={name}
                              src={avatar}
                              style={{
                                height: 30,
                                width: 30
                              }}
                            />
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                              <Typography variant="subtitle2" flexWrap={'wrap'}>
                                {name || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                        {/* SELLER */}
                        <TableCell align="left">
                          <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                            {email || 'N/A'}
                          </div>
                          {/* <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 150 }}
                          >
                            <Avatar
                              alt={seller?.name}
                              src={seller?.avatar}
                              style={{
                                height: 30,
                                width: 30
                              }}
                            />
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                              <Typography variant="subtitle2" flexWrap={'wrap'}>
                                {seller?.name || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack> */}
                        </TableCell>
                        {/* SELLER EARNINGS */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_orders_count}
                          </Typography>
                        </TableCell>

                        {/* protecction FEE */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_buyer_protection_fee}
                          </Typography>
                        </TableCell>

                        {/* SHIPPING FEE */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_earning}
                          </Typography>
                        </TableCell>
                        {/* Action */}
                        <TableCell style={{ position: 'relative', minHeight: 400 }}>
                          {permission.includes('details') && (
                            <Tooltip title="View Details">
                              <LoadingButton
                                size="small"
                                onClick={(event) => {
                                  // event.preventDefault();
                                  // event.stopPropagation();
                                  setdetailloading(true);
                                  handlegetearningbyid(id);
                                  setearningdetailmodal(true);
                                }}
                                style={{
                                  justifyContent: 'center',
                                  width: 30, // Less than 30
                                  height: 30, // Ensuring it's a square button
                                  minWidth: 30, // Ensuring minimum width is set to 30
                                  padding: 0, // Removing padding to fit the icon properly
                                  lineHeight: 1, // Ensuring the icon is centered
                                  alignSelf: 'center',
                                  marginLeft: 1
                                }}
                                // component={RouterLink}
                                to="#"
                              >
                                <Iconify
                                  style={{ cursor: 'pointer', fontSize: 18 }}
                                  icon="gg:notes"
                                />
                              </LoadingButton>
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* PROTECTION FEE */}
                        {/* <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_vint_earning_sum || 'N/A'}
                          </Typography>
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isDataFound && !loading && !searchLoading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </Scrollbar>
          </TableContainer>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
